// Bancos de Guatemala (fuente única para selects en todo el sistema).
export const GT_BANKS = [
  "Banco Industrial",
  "Banrural",
  "Banco G&T Continental",
  "Banco Agromercantil (BAM)",
  "BAC Credomatic",
  "Banco Promerica",
  "Banco de los Trabajadores (Bantrab)",
  "Banco Ficohsa",
  "Banco Inmobiliario",
  "Vivibanco",
  "Banco de Antigua",
  "Banco Azteca",
  "Citibank",
  "Banco Internacional (Interbanco)",
  "Banco de América Central",
  "Otro",
];

export const BANK_ACCOUNT_TYPES = ["Monetaria", "Ahorro", "Plazo fijo"];
